import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import {
  Accordion,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion';

import expandIcon from '../../../images/accordion-expand.svg';
import collapseIcon from '../../../images/accordion-collapse.svg';

export const StyledAccordionBody = styled(AccordionItemPanel)`
  width: 100%;
  padding: 0 30px 40px;
  animation: fadein 0.35s ease-in;

  @keyframes fadein {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  > p:first-of-type {
    border-top: 1px solid ${themeGet('colors.stone', '#EBEDEB')};
  }
`;

export const AccordionWrapper = styled(Accordion)`
  width: 100%;
  border-bottom: 1px solid ${themeGet('colors.cta-border-grey')};
`;

export const StyledAccordionItemButton = styled(AccordionItemButton)`
  position: relative;
  padding: 2.25rem 1.5rem;

  &[aria-expanded='false'] {
    p {
      &:after {
        content: '';
        height: 1.5rem;
        width: 1.5rem;
        background-image: url(${expandIcon});
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      }
    }
  }

  &[aria-expanded='true'] {
    p {
      &:after {
        content: '';
        height: 1.5rem;
        width: 1.5rem;
        background-image: url(${collapseIcon});
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      }
    }
  }

  p {
    position: relative;
    margin-right: 24px;
    line-height: 150%;

    &:after {
      position: absolute;
      right: -24px;
      top: 2px;
    }
  }
`;

export const StyledAccordionItemTitle = styled(AccordionItemHeading)`
  width: 100%;
  cursor: pointer;
`;

export const AccordionText = styled.p`
  padding-top: 20px;
`;
